export enum FoundPrecatorioStatusEnum {
    FOUND_VALID_PRECATORIO = "FOUND_VALID_PRECATORIO",
    DONT_FOUND_PRECATORIO = "DONT_FOUND_PRECATORIO",
    FOUND_INVALID_PRECATORIO = "FOUND_INVALID_PRECATORIO"
  }


// WEBPACK FOOTER //
// ./src/services/Enum/dap/FoundPrecatorioStatusEnum.ts